import { Client } from "@microsoft/microsoft-graph-client";

export const getGraphClient = (accessToken) => {
    return Client.init({
        authProvider: (done) => {
            done(null, accessToken);
        }
    });
};